import { HpDispatchFunction } from '../types/actionTypes';
import { HpSetActiveSectionActionPayload, HpSetActiveSectionDispatchFunction } from './eventActionTypes';

// eslint-disable-next-line @typescript-eslint/ban-types
export function setActiveSectionAction(payload: HpSetActiveSectionActionPayload): HpSetActiveSectionDispatchFunction {
  return (dispatch: HpDispatchFunction<HpSetActiveSectionActionPayload>): void => {
    dispatch({ type: 'SET_ACTIVE_SECTION', payload });
  };
}
